import { IPage } from '../interfaces';
import { PaginationDefinition } from '../models/definition';

export class Page implements IPage {
	public readonly size: number = PaginationDefinition.PAGE_SIZE;
	public _previousPageNumber = 1;
	private _start: number;

	public constructor(private _pageNumber: number = PaginationDefinition.DEFAULT_PAGE_NUMBER) {
		this.setPreviousPageNumber();

		this._start = this.calculateStart();
	}

	get start(): number {
		return this._start;
	}

	get previousPageNumber(): number {
		return this._previousPageNumber;
	}

	public get pageNumber(): number {
		return this._pageNumber;
	}

	public setPreviousPageNumber(): void {
		this._previousPageNumber = this._pageNumber;
	}

	public setPageNumber(pageNumber: number): void {
		this._pageNumber = pageNumber;
		this._start = this.calculateStart();
	}

	public getUrlPathPart(): string {
		if (this._pageNumber === 2) {
			return `${PaginationDefinition.PAGE_TWO}`;
		}

		return '';
	}

	private calculateStart(): number {
		return PaginationDefinition.PAGE_SIZE * this._pageNumber - PaginationDefinition.PAGE_SIZE;
	}
}
